import React from 'react'
import { useTranslation } from 'react-i18next'
import { Header, Button } from 'components/common'
import signupComplete from 'assets/images/cardholderSignupComplete.png'

export const Step4 = () => {
  const { t } = useTranslation('pub', {
    keyPrefix: 'PublicRoutes.signUp',
  })

  return (
    <div className="form-step step-complete-container">
      <Header as="h1">{t('success')}</Header>
      <Header as="h2">
        {t('buildProfileHeading', "We're building your risk profile.")}
      </Header>
      <div className="onboard-message">
        {t(
          'successMessageCardholder',
          'We’re building your company profile and performing a risk assessment. Once complete, we will send you a notification email. If you have questions, please contact ',
        )}
        <a id="support-email" href="mailto:support@riskrecon.com">support@riskrecon.com</a>.
      </div>
      <img src={signupComplete} alt="" />
      <div className="step-navigation">
        <Button
          color="blue"
          onClick={() => (window.location.href = '/welcome')}
        >
          {t('goToDashboard', 'Return to Home')}
        </Button>
      </div>
    </div>
  )
}
